import { Button, Collapse, ListItem } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

const styles = {
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%'
  },
  buttonLeaf: (theme) => ({
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&.depth-0': {
      fontWeight: theme.typography.fontWeightMedium
    }
  }),
  icon: (theme) => ({
    color: theme.palette.icon,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  }),
  expandIcon: {
    marginLeft: 'auto',
    height: 16,
    width: 16
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto'
  },
  active: (theme) => ({
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    }
  })
};

function NavItem({
  title,
  href,
  depth,
  children,
  icon: Icon,
  className,
  open: openProp = false,
  label: Label,
  ...rest
}) {
  const [open, setOpen] = useState(openProp);

  useEffect(() => {
    setOpen(openProp);
  }, [openProp]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = {
    paddingLeft
  };

  if (children) {
    return (
      <ListItem
        {...rest}
        className={className}
        sx={styles.item}
        disableGutters
        key={title}
      >
        <Button
          sx={styles.button}
          color="inherit"
          onClick={handleToggle}
          style={style}
        >
          {Icon && <Icon sx={styles.icon} color="inherit" />}
          {title}
          {open ? (
            <ExpandLessIcon
              sx={styles.expandIcon}
              color="inherit"
            />
          ) : (
            <ExpandMoreIcon
              sx={styles.expandIcon}
              color="inherit"
            />
          )}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }


  if (href === undefined){
    return <div></div>
  }


  return (
    <ListItem
      {...rest}
      className={className}
      sx={styles.itemLeaf}
      disableGutters
      key={title}
    >
      {href[0] === '/' ? <Button
        className={`depth-${depth}`}
        sx={styles.buttonLeaf}
        color="inherit"
        component={RouterLink}
        end
        style={style}
        to={href}
      >
        {Icon && <Icon sx={styles.icon} color="inherit" />}
        {title}
        {Label && (
          <span style={styles.label}>
            <Label />
          </span>
        )}
      </Button>
        :
        <Button
          className={`depth-${depth}`}
          sx={styles.buttonLeaf}
          color="inherit"
          onClick={() => window.open(href, '_blank')}
          style={style}
        >
          {Icon && <Icon sx={styles.icon} color="inherit" />}
          {title}
          {Label && (
            <span style={styles.label}>
              <Label />
            </span>
          )}
        </Button>
      }
    </ListItem>
  );
}

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.any,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired
};

export default NavItem;
